import { Vendor } from '@/classes/vendor';
import { Commit, Dispatch } from 'vuex';
import axios from '../../axios-vendor'

const baseURL = "/vendors";

export default ({
    namespaced: true,
    state : {
        vendor: new Vendor
    },
    actions: {
        setVendor: ({commit}:{commit: Commit} , vendor: Vendor) => commit('SET_AUTH_VENDOR', vendor),

        async logout () {
            const {data} = await axios.get(`/logout`)
            return data
        },
        async updateProfile({dispatch}: {dispatch: Dispatch}, payload={id: ''}){
            const { data } = await axios.put(`${baseURL}/update-profile/${payload.id}`, payload);
            dispatch('index');
            return data
        },
        async updatePassword({dispatch}: {dispatch: Dispatch}, payload={}){
            const { data } = await axios.post(`${baseURL}/update-password`, payload);
            dispatch('index');
            return data
        },

    },
    mutations: {
        SET_AUTH_VENDOR(state: {vendor: Vendor}, vendor: Vendor ){
            state.vendor = vendor
        },
    },
    getters: {
        auth_vendor(state: {vendor: Vendor}){
            return state.vendor;
        },

        auth_id(state: {vendor: Vendor}):string{
            return state.vendor.id;
        },
        // department_head_id(state: {user: User}):string{
        //     return state.user.head;
        // },
        // permissions(state: {user: User}){
        //     return state.user.permissions
        // }
    }
})
